export const scrollToElementIfNeeded = (element: HTMLElement, parent: HTMLElement) => {
  const rect = element.getBoundingClientRect();
  const isVisible =
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <= parent.clientHeight &&
    rect.right <= parent.clientWidth;

  if (!isVisible) {
    const currentScrollPosition = window.scrollX;
    element.scrollIntoView({ behavior: 'auto', block: 'nearest', inline: 'start' });
    window.scrollTo(currentScrollPosition, window.scrollY);
  }
};
